exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-inner:has(.v-bootstrap-tooltip-custom) {\n  max-width: 450px !important;\n  padding: 0.25rem 0.5rem !important;\n  color: #fff !important;\n  text-align: center !important;\n  background-color: #000 !important;\n  border-radius: 0.25rem !important;\n  margin-left: -200px !important;\n}\n", ""]);

// exports
